(function () {
  'use strict';

  var PORTAL_URL = (window.CDI_PORTAL_URL || '').replace(/\/$/, '');
  var STATUS_TEXT = {
    in_stock:  'In stock',
    backorder: 'Back-order',
    out:       'Out of stock',
  };
  function applyState(root, locationName, state) {
    var row = root.querySelector('[data-location="' + locationName + '"]');
    if (!row) return;
    var dot    = row.querySelector('.cdi-fulfillment__dot');
    var status = row.querySelector('.cdi-fulfillment__wh-status');

    if (dot) {
      dot.className = 'cdi-fulfillment__dot cdi-fulfillment__dot--' + state;
    }
    if (status) {
      status.textContent = STATUS_TEXT[state] || '';
    }
  }
  function fallbackStateFromShopify(d) {
    var qty = parseInt(d.shopifyQty, 10);
    if (qty > 0) return 'in_stock';
    if (d.policy === 'continue') return 'backorder';
    return 'out';
  }
  function applyFallback(root) {
    var d = getVariantData(root);
    var state = fallbackStateFromShopify(d);
    root.dataset.fulfillmentMode = 'aggregate';
    applyState(root, 'brisbane', state);
  }
  function resetToLoading(root) {
    delete root.dataset.fulfillmentMode;
    root.querySelectorAll('.cdi-fulfillment__dot').forEach(function (dot) {
      dot.className = 'cdi-fulfillment__dot';
    });
    root.querySelectorAll('.cdi-fulfillment__wh-status').forEach(function (el) {
      el.textContent = '';
    });
  }
  function getVariantData(root) {
    var meta = root.querySelector('.cdi-fulfillment__meta');
    var src  = meta || root;
    return {
      sku:        (src.dataset.sku        || '').trim(),
      policy:     src.dataset.inventoryPolicy || 'deny',
      shopifyQty: src.dataset.shopifyQty      || '0',
    };
  }
  var abortControllers = new WeakMap();
  var REQUEST_TIMEOUT_MS = 8000;

  function fetchAndRender(root) {
    var d        = getVariantData(root);
    var sku      = d.sku;
    var policy   = d.policy;
    if (!sku || !PORTAL_URL) {
      applyFallback(root);
      return;
    }
    var previousController = abortControllers.get(root);
    if (previousController) previousController.abort();
    var controller = new AbortController();
    abortControllers.set(root, controller);
    var url = PORTAL_URL + '/api/internal/inventory?sku=' + encodeURIComponent(sku);
    resetToLoading(root);
    var timedOut = false;
    var timer = setTimeout(function () {
      timedOut = true;
      controller.abort();
    }, REQUEST_TIMEOUT_MS);
    fetch(url, { method: 'GET', cache: 'default', signal: controller.signal })
      .then(function (res) {
        clearTimeout(timer);
        if (res.status === 404) {
          applyFallback(root);
          return null;
        }
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data) return;
        if (typeof data.brisbane !== 'string' && typeof data.sydney !== 'string') {
          throw new Error('Unexpected response');
        }
        root.dataset.fulfillmentMode = 'per-warehouse';
        ['brisbane', 'sydney'].forEach(function (loc) {
          var status = data[loc];
          var state;
          if (status === 'in_stock') {
            state = 'in_stock';
          } else if (policy === 'continue') {
            state = 'backorder';
          } else {
            state = 'out';
          }
          applyState(root, loc, state);
        });
      })
      .catch(function (err) {
        clearTimeout(timer);
        if (err && err.name === 'AbortError' && !timedOut) return;
        if (abortControllers.get(root) !== controller) return;
        applyFallback(root);
      });
  }
  function refreshAllRoots() {
    document.querySelectorAll('[id^="FulfillmentInfo-"]').forEach(function (root) {
      if (root.querySelector('.cdi-fulfillment__list')) {
        fetchAndRender(root);
      }
    });
  }
  function init() {
    refreshAllRoots();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, refreshAllRoots);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
